export const SUBTYPE_MAPPING: { [key: string]: string } = {
    MONOLITHIC: 'Monolithic',
    LAMINATE: 'Laminate',
    INTERLAYER: 'Interlayer',
    EMBEDDED_COATING: 'Embedded coating',
    COATED: 'Coated glass',
    COATING: 'Coating',
    APPLIED_FILM: 'Applied film',
    FILM: 'Film',
    FRITTED_GLASS: 'Fritted glass',
    SANDBLASTED_GLASS: 'Sandblasted glass',
    ACID_ETCHED_GLASS: 'Acid etched glass',
    CHROMOGENIC: 'Chromogenic',
    VENETIAN_BLIND: 'Venetian blind',
    VERTICAL_LOUVER: 'Vertical louver',
    PERFORATED_SCREEN: 'Perforated screen',
    WOVEN_SHADE: 'Woven shade',
    ROLLER_SHADE: 'Roller shade',
    CELLULAR_SHADE: 'Cellular shade',
    PLEATED_SHADE: 'Pleated Shade',
    ROMAN_SHADE: 'Roman shade',
    DIFFUSING_SHADE: 'Diffusing shade',
    SOLAR_SCREEN: 'Solar screen',
    SHADE_MATERIAL: 'Shade material',
    UNKNOWN: 'Unknown'
};